<template>
  <div
    v-if="loading"
    class="spinner-border text-primary"
    role="status"
  >
    <span class="sr-only">Loading...</span>
  </div>
</template>
<script>
export default {
    name: 'Loading',
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
